
import { API_URLS } from "../url";
import axiosInstance from "../axiosInstance";
import { showToast } from "../../utils/toast";

export const googleSignupApi = async (code: string) => {
  try {
    const { data } = await axiosInstance.post(API_URLS.GOOGLE_SIGNUP, { code });

    return data;
  } catch (error: any) {
    if (
      !error.response ||
      error.code === "ECONNABORTED" ||
      error.message?.includes("timeout")
    ) {
      // Network / timeout / offline
      showToast.error("Network error. Please try again.");
    }
    throw error;
  }
};